'use client';

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionItem, AccordionTrigger } from '../ui/accordion';

const AREAS = [
  {
    id: '0',
    color: '#3C6E71',
    title: 'Direito Cível',
    description:
      'Nosso escritório em Biguaçu/SC atua em Direito Cível, ramo que regula as relações privadas entre pessoas físicas e jurídicas. Tratamos de contratos, obrigações, responsabilidade civil, sucessões, bens e direitos reais. Atendemos clientes em Biguaçu, Florianópolis, São José e toda a Grande Florianópolis, garantindo segurança jurídica e equilíbrio nas relações interpessoais.',
  },
  {
    id: '1',
    color: '#2EC4B6',
    title: 'Direito Imobiliário',
    description:
      'Atuamos em Direito Imobiliário em Biguaçu e região da Grande Florianópolis, regulando relações jurídicas envolvendo bens imóveis. Abrangemos compra e venda de imóveis, locações, financiamentos, usucapião, registro de propriedade, incorporações e regularizações. Nosso objetivo é garantir segurança jurídica nas transações imobiliárias em Biguaçu/SC e proteger os direitos de proprietários, possuidores, herdeiros, compradores, locadores e locatários.',
  },
  {
    id: '2',
    color: '#5F6CAF',
    title: 'Assessoria Jurídica',
    description:
      'Oferecemos assessoria jurídica especializada em Biguaçu/SC, com suporte contínuo para pessoas físicas e jurídicas na tomada de decisões legais. Realizamos análise de contratos, prevenção de litígios, adequação à legislação vigente e suporte em negociações, garantindo segurança jurídica e conformidade com a lei. Atendemos empresas e profissionais em Biguaçu, Florianópolis e toda Santa Catarina.',
  },
  {
    id: '3',
    color: '#F4A261',
    title: 'Direito Público e Administrativo',
    description:
      'Em nosso escritório em Biguaçu/SC, atuamos em Direito Público, que regula as relações entre o Estado e os cidadãos, e em Direito Administrativo, que trata da organização, funcionamento e controle da Administração Pública. Assessoramos clientes em Biguaçu e região em questões envolvendo atos administrativos, licitações, servidores e contratos públicos.',
  },
  {
    id: '4',
    color: '#F28482',
    title: 'Direito de Família',
    description:
      'Nosso escritório em Biguaçu/SC é especializado em Direito de Família, atuando em casamento, união estável, divórcio, guarda de filhos, pensão alimentícia, adoção e reconhecimento de paternidade. Atendemos famílias em Biguaçu, Florianópolis, São José e Palhoça, sempre priorizando o bem-estar dos membros da família e o melhor interesse da criança e do adolescente.',
  },
  {
    id: '5',
    color: '#E391ED',
    title: 'Direito Tributário',
    description:
      'Atuamos em Direito Tributário em Biguaçu/SC e região, regulando a relação entre o Estado e os contribuintes na cobrança de tributos. Tratamos de impostos, taxas, contribuições, fiscalizações e defesas administrativas e judiciais. Protegemos os direitos dos contribuintes em Biguaçu, Florianópolis e toda Santa Catarina, assegurando a correta aplicação da legislação fiscal.',
  },
];

export default function AreaSection() {
  const [openItems, setOpenItems] = useState<string[]>([]);

  const toggleItem = (id: string) => {
    if (openItems.includes(id)) {
      setOpenItems(openItems.filter((x) => x !== id));
    } else {
      setOpenItems([id]);
    }
  };

  return (
    <section className="flex justify-center w-full bg-[#FFFBF5]">
      <div className="flex flex-col px-5 py-10 lg:px-20 lg:py-20 lg:max-w-7xl mx-auto w-full">
        <h2 className="text-[#192437] text-lg font-bold tracking-widest mb-6">ÁREAS DE ATUAÇÃO</h2>

        <Accordion type="single" collapsible className="w-full">
          {AREAS.map((area) => {
            const isOpen = openItems.includes(area.id);
            return (
              <AccordionItem
                key={area.title}
                value={area.id}
                className="rounded-xl shadow-sm mb-4 bg-white hover:opacity-80 transition"
              >
                <AccordionTrigger
                  className="text-lg font-semibold px-6 py-3 hover:no-underline items-center"
                  style={{ color: area.color }}
                  onClick={() => toggleItem(area.id)}
                >
                  {area.title}
                </AccordionTrigger>
                <motion.div
                  initial={{ height: 0 }}
                  animate={{ height: isOpen ? 'auto' : 0 }}
                  transition={{ duration: 0.25, ease: 'linear' }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pt-0 pb-6">
                    <p className="text-primary text-sm text-justify font-medium">
                      {area.description}
                    </p>
                  </div>
                </motion.div>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
